import { FadeLoader } from "react-spinners";
import "./delete.scss";
import { MdDelete } from "react-icons/md";

export default function Delete({
  setIsDelete,
  handleDeleteSelected,
  isLoading,
}) {
  const handleDelete = () => {
    setIsDelete(false);
  };

  return (
    <div className="flex-col-center Delete">
      <div className="flex-row-center deleteBtn">
        <MdDelete />
      </div>
      <p className="title">Are you sure ?</p>
      <div className="flex-row-center btnContainer">
        <button
          onClick={() => setIsDelete(false)}
          className="btn cancel flex-row-center"
        >
          Cancel
        </button>
        <button
          onClick={handleDeleteSelected}
          className="btn delete flex-row-center"
        >
          {isLoading ? <div className="deleteLoadingGallary"></div> : "Delete"}
        </button>
      </div>
    </div>
  );
}
